module.exports = __webpack_public_path__ + "static/media/2023_23.211ff64f.jpg";